export abstract class NotificationStrategy {
    abstract success(message: string, options?: any): void;
    abstract error(message: string, title?: string, options?: any): void;
    abstract warning(message: string, options?: any): void;
    abstract info(message: string, options?: any): void;
    abstract show(message: string, title?: string, options?: any, type?: string): void;
}
